module.exports = "/assets/data/efad532b2bfbd9cfc27f3d0d99847f60-NG16.data.json";